import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', 
    supportedLngs: ['en', 'es', 'fr', 'pt', 'zh', 'hi', 'ar', 'ru', 'de', 'ja', 'sw', 'bn', 'id', 'ur', 'vi', 'ko', 'it', 'tr', 'tl', 'am'], 

    backend: {
      loadPath: `${process.env.REACT_APP_DJANGO_URL}/api/translations/{{lng}}/translation.json`,
    },

    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], 
      caches: ['localStorage', 'cookie'], 
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true, // Enables React suspense for loading translations
    },
  });

export default i18n;
